export default __webpack_public_path__ + "static/media/butcher4.0b39854d.png";